import { Newspaper } from "lucide-react";
import { useTranslation } from "react-i18next";
import logo from "@/src/common/assets/images/logo.png";
import dmReactionsImage from "@/src/marketing/assets/screenshots/dm-reactions.jpg";
import immersiveImage from "@/src/marketing/assets/screenshots/feed-immersive-tacos.jpg";
import { RevealOnView } from "../reveal-on-view";

export function FeaturesSection() {
	const { t } = useTranslation("marketing");

	return (
		<section id="features" className="grid scroll-mt-28 gap-12 py-24 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
			<RevealOnView from="left">
				<div>
					<p className="text-sm font-semibold uppercase tracking-[0.24em] text-app-accent-secondary">{t("section_features_eyebrow")}</p>
					<h2 className="mt-4 text-4xl font-semibold tracking-[-0.06em] text-white sm:text-5xl">{t("section_features_title")}</h2>
				</div>
			</RevealOnView>
			<div className="flex flex-col gap-4">
				<RevealOnView from="right">
					<div className="flex items-start gap-3 rounded-3xl border border-white/10 bg-white/6 p-5 shadow-[0_16px_40px_-34px_rgba(0,0,0,0.6)] backdrop-blur">
						<div className="mt-0.5 inline-flex size-10 shrink-0 items-center justify-center rounded-2xl bg-white/8 text-app-accent">
							<Newspaper className="size-5" />
						</div>
						<p className="text-sm font-medium leading-7 text-white/70">{t("feature_list_news")}</p>
					</div>
				</RevealOnView>
				<RevealOnView className="relative" delayMs={60} from="up">
					<div className="relative">
						<div className="absolute inset-x-10 top-12 h-72 rounded-full bg-[linear-gradient(135deg,rgba(255,90,95,0.24),rgba(255,154,90,0.16),rgba(78,141,255,0.16))] blur-3xl" />
						<div className="relative mx-auto max-w-xl">
							<div className="rounded-[2.6rem] border border-white/10 bg-[linear-gradient(180deg,rgba(15,20,32,0.86),rgba(12,17,27,0.8))] p-4 shadow-[0_36px_90px_-48px_rgba(0,0,0,0.72)] backdrop-blur">
								<div className="rounded-[2.2rem] border border-white/10 bg-[linear-gradient(180deg,rgba(15,20,32,0.92),rgba(8,11,18,0.92))] p-6">
									<div className="flex items-center justify-between rounded-[1.6rem] border border-white/8 bg-black/30 px-5 py-4 text-white shadow-[0_20px_40px_-30px_rgba(0,0,0,0.9)]">
										<div>
											<p className="text-xs uppercase tracking-[0.24em] text-white/40">LookDat</p>
											<p className="mt-2 text-lg font-semibold tracking-[-0.03em]">{t("feature_screenshot_header")}</p>
										</div>
										<img
											src={logo}
											alt="LookDat app icon"
											width={48}
											height={48}
											loading="lazy"
											decoding="async"
											className="size-12 rounded-2xl"
										/>
									</div>
									<div className="mt-5 grid gap-4 sm:grid-cols-2">
										<div className="overflow-hidden rounded-[1.8rem] border border-white/10 bg-white/6 shadow-[0_24px_40px_-28px_rgba(0,0,0,0.5)]">
											<img
												src={immersiveImage}
												alt={t("screenshot_feed_alt")}
												loading="lazy"
												decoding="async"
												className="block h-full w-full object-cover"
											/>
										</div>
										<div className="overflow-hidden rounded-[1.8rem] border border-white/10 bg-white/6 shadow-[0_24px_40px_-28px_rgba(0,0,0,0.5)]">
											<img
												src={dmReactionsImage}
												alt={t("screenshot_reactions_alt")}
												loading="lazy"
												decoding="async"
												className="block h-full w-full object-cover"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</RevealOnView>
			</div>
		</section>
	);
}
